module.exports = __webpack_public_path__ + "static/img/tax-swiper.73653ba2.jpg";